/** Le fichier choisi est fixe pour la durée du document : une ancienne sauvegarde différée
 * ne doit jamais recevoir les en-têtes du nouveau fichier. Changer de fichier recharge l’hôte,
 * dont les fenêtres et brouillons conservent leur mécanisme de restauration habituel. */
export interface MissionSelection {
  runId: string;
  title: string;
}
let selected: MissionSelection | null = null;
let actorId: string | null = null;
const key = (userId: string) => `ndrc:mission-selection:${userId}`;

export function parseMissionSelection(raw: string | null): MissionSelection | null {
  try {
    const value: unknown = JSON.parse(raw ?? 'null');
    if (!value || typeof value !== 'object') return null;
    const candidate = value as Record<string, unknown>;
    if (
      typeof candidate.runId !== 'string' ||
      !/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(candidate.runId) ||
      typeof candidate.title !== 'string' ||
      candidate.title.length > 500
    )
      return null;
    return { runId: candidate.runId, title: candidate.title };
  } catch {
    return null;
  }
}

export function initializeMissionSelection(userId: string, role: string): void {
  if (role !== 'student' && role !== 'teacher') {
    actorId = userId;
    selected = null;
    return;
  }
  if (actorId === userId) return;
  actorId = userId;
  try {
    selected = parseMissionSelection(sessionStorage.getItem(key(userId)));
  } catch {
    selected = null;
  }
}

export function missionSelection(): MissionSelection | null {
  return selected;
}

export function switchMissionSelection(
  userId: string,
  next: MissionSelection | null,
  path = '/',
): void {
  if (next) sessionStorage.setItem(key(userId), JSON.stringify(next));
  else sessionStorage.removeItem(key(userId));
  // Ne pas modifier `selected` avant le rechargement : les requêtes encore en vol restent liées
  // au fichier dans lequel elles ont été préparées.
  window.location.assign(path);
}
